import { DropdownItem, IconName, isMultileg, type Security } from '@talos/kyoko';
import { memo } from 'react';

interface CloneSymbolDropdownItemProps {
  security: Security | undefined;
  onCloneSymbol?: (security: Security) => void;
}

export const CloneSymbolDropdownItem = memo(function CloneSymbolDropdownItem({
  security,
  onCloneSymbol,
}: CloneSymbolDropdownItemProps) {
  if (!security || !isMultileg(security) || !onCloneSymbol) {
    return null;
  }

  return (
    <DropdownItem
      startIcon={IconName.Duplicate}
      onClick={() => onCloneSymbol(security)}
      data-testid="clone-symbol-dropdown-item"
    >
      Clone Symbol
    </DropdownItem>
  );
});
